module.exports = __webpack_public_path__ + "assets/img/solutions2.9d9a03dd.png";